import {Box, Divider, Stack, useTheme} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import {CervinoHeaderText} from "../typography/CervinoHeaderText";
import {InstagramStyleMarquee} from "./Carousels/InstagramStyleMarquee";
import ScrollSettleIn from "../animations/ScrollSettleIn";
import HorizontalLogoContactCard from "./HorizontalLogoContactCard";
import { trackEvent } from "../../utils/analytics";
import decoration2 from "../../assets/icons/SM_short_flower_white.png";
import decoration from "../../assets/icons/SM_long_flower_white.png";
import React from "react";

// Instagram posts
import image1 from "../../assets/instagramPosts/image1.png"
import image2 from "../../assets/instagramPosts/image2.png"
import image3 from "../../assets/instagramPosts/image3.jpg"
import image4 from "../../assets/instagramPosts/image4.png"
import image5 from "../../assets/instagramPosts/image5.png"
import image6 from "../../assets/instagramPosts/image6.jpg"
import image7 from "../../assets/instagramPosts/image7.png"

export default function SMFooter() {
    const theme = useTheme();

    const posts = [
        { id: "1", type: "image", src: image1 },
        { id: "2", type: "video", src: image2 },
        { id: "3", type: "image", src: image3, },
        { id: "4", type: "video", src: image4, },
        { id: "5", type: "video", src: image5, },
        { id: "6", type: "video", src: image6, },
        { id: "7", type: "video", src: image7, },
    ];

    return (
    <>
        <Divider
            sx={{
                height: 1,
                backgroundColor: theme.palette.primary.main,
            }}
        />

        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
            }}
        >
            <Box
                component="a"
                href="https://www.instagram.com/sanmiguel.us?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("social_click", { platform: "instagram", location: "footer_header" })}
                sx={{
                    textDecoration: "none",
                    color: "inherit",
                    paddingRight: { xs: 2, sm: 3 },
                }}
            >
                <Stack direction="row" spacing={1} alignItems="flex-end">
                    <InstagramIcon sx={{fontSize: { xs: 22, sm: 30, md: 40 }}} />
                    <CervinoHeaderText sx={{fontSize:{ xs: "1.125rem", sm: "1.5rem", md: "2rem", lg: "2rem", xl: "2rem" }}}>
                        @sanmiguel.us
                    </CervinoHeaderText>
                </Stack>
            </Box>
        </Box>

        <Box sx={{ position: "relative", zIndex: 1 }}>
            <InstagramStyleMarquee
                items={posts}
                profileUrl="https://www.instagram.com/sanmiguel.us?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                speed={0.7}
                pauseOnHover
                showTypeIcon
            />
        </Box>

        <ScrollSettleIn
            minOpacity={0}
            endAtVh={{ xs: 0.76, sm: 0.78, md: 0.80, lg: 0.80, xl: 0.80 }}
            startOffsetPx={{ xs: 300, sm: 380, md: 420, lg: 450, xl: 450 }}
            sx={{ paddingY: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }, paddingX: 1 }}
        >
            <HorizontalLogoContactCard
                logoSrc="/images/SM_whiteLogo.png"
                patternSrc1={decoration2}
                patternSrc2={decoration}
                whatsappNumber="16193842096"
                email="jp.madrazo@sanmiguel.me"
                onWhatsappClick={() => trackEvent("contact_click", { method: "whatsapp" })}
                onEmailClick={() => trackEvent("contact_click", { method: "email" })}
            />
        </ScrollSettleIn>
    </>
    );
}